import React, { useState } from "react";
import { FaCheckCircle, FaStar, FaStarHalf, FaStarHalfAlt } from "react-icons/fa";

 
  
const ratingLabels = {
  0.5: "😞 Sad",
  1: "😕 Poor",
  1.5: "😐 Okay",
  2: "🙂 Fine",
  2.5: "😊 Good",
  3: "😃 Nice",
  3.5: "😁 Great",
  4: "🤩 Wow",
  4.5: "🔥 Amazing",
  5: "👑 Perfect",
};

const StarRating = ({ value, onChangeVal ,styleObj={bgColor:"rgba(144, 202, 249,0.41)",color:"#222222",border:"2px solid rgba(144, 202, 249,1)"}}) => {
   const [showSnack, setShowSnack] = useState(false);
const handleClick = (val) => {
    onChangeVal(val);
    setShowSnack(true);

    setTimeout(() => setShowSnack(false), 1800);
  };

  const [hover, setHover] = useState(null);
  const current = hover ?? value;
 
  return (<div style={{ position: "relative", }}>{/* Snackbar */}
      {showSnack && (
        <div
          style={{
            position: "absolute",
            top: -48,
            left: "50%",
            transform: "translateX(-50%) scale(1)",
            background: "#111827",
            color: "#fff",
            padding: "8px 14px",
            borderRadius: 10,
            display: "flex",width:"110px",
            alignItems: "center",
            gap: 8,
            fontSize: 14,
            animation: "snackIn 200ms ease-out",
            pointerEvents: "none",
            zIndex: 10,
          }}
        >
          <FaCheckCircle
            style={{
              color: "#22c55e",
              animation: "checkPop 300ms ease",
            }}
          />
          Thank you !!!
        </div>
      )}
      <div style={{display: "flex" ,justifyContent:"space-between"}}>
    <div style={{ display: "flex", gap: 10 }}>

      {[0, 1, 2, 3, 4].map((i) => {
        const tooltipText = ratingLabels[hover];

        return (
          <div
            key={i}
            style={{
              position: "relative",
              width: 26,
              height: 36,
            }}
          >
            {/* Tooltip */}
            {hover && hover > i && hover <= i + 1 && (
              <div
                style={{
                  position: "absolute",
                  top: -28,
                  left: "50%",
                  transform: "translateX(-50%)",
                  background: "#111827",
                  color: "#fff",
                  padding: "4px 8px",
                  borderRadius: 6,
                  fontSize: 12,
                  whiteSpace: "nowrap",
                  pointerEvents: "none",
                  opacity: 1,
                  transition: "opacity 150ms ease",
                }}
              >
                {tooltipText}
              </div>
            )}

            {/* Base gray star */}
            <FaStar
              style={{
                position: "absolute",
                fontSize: 26,
                color: "#eeeeee",
              }}
            />

            {/* Half yellow */}
            {current >= i + 0.5 && current < i + 1 && (
              <FaStarHalf
                style={{
                  position: "absolute",
                  fontSize: 26,
                  color: "#facc15",
                  transition: "all 150ms ease",
                }}
              />
            )}

            {/* Full yellow */}
            {current >= i + 1 && (
              <FaStar
                style={{
                  position: "absolute",
                  fontSize: 26,
                  color: "#facc15",
                  transition: "all 150ms ease",
                }}
              />
            )}

            {/* Interaction zones */}
            <div
              style={{
                position: "absolute",
                inset: 0,
                display: "flex",
                zIndex: 2,
              }}
            >
              <span
                style={{ width: "50%", height: "100%", cursor: "pointer" }}
                onMouseEnter={() => setHover(i + 0.5)}
                onMouseLeave={() => setHover(null)}
                onClick={() => handleClick(i + 0.5)}
              />
              <span
                style={{ width: "50%", height: "100%", cursor: "pointer" }}
                onMouseEnter={() => setHover(i + 1)}
                onMouseLeave={() => setHover(null)}
                onClick={() => handleClick(i + 1)}
              />
            </div>
          </div>
        );
      })}
      {/* Animations */}
      <style>{`
        @keyframes snackIn {
          from {
            opacity: 0;
            transform: translateX(-50%) translateY(6px) scale(0.95);
          }
          to {
            opacity: 1;
            transform: translateX(-50%) translateY(0) scale(1);
          }
        }

        @keyframes checkPop {
          0% { transform: scale(0.6); }
          70% { transform: scale(1.2); }
          100% { transform: scale(1); }
        }
      `}</style>
     
    </div>
     <button onClick={()=>{}}style={{
        background:styleObj?.bgColor,color:styleObj?.color,border:styleObj?.border,
        borderRadius:"10px",fontSize:"12px",cursor:"pointer"}}>Add Review</button>
    </div>
    </div>
  );
};

export default StarRating;
